exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrollable {\r\n    height: 88%;\r\n    overflow: auto;\r\n}\r\n\r\n.scrollable::-webkit-scrollbar {\r\n    display: none;\r\n}\r\n\r\nheader {\r\n    text-align: center;\r\n    padding: 20px;\r\n    background-color: #011526;\r\n    margin-bottom: 10px;\r\n    border-radius: 2px;\r\n    opacity: 0.95;\r\n}\r\n\r\n.search-input{\r\n    background-color: transparent;\r\n    color: #F2D608;\r\n    border-style: solid;\r\n    border-color: #F2D608;\r\n    border-width: 2px;\r\n    text-align: center;\r\n    border-radius: 4px;\r\n    transition: border-width 0.2s;\r\n}\r\n\r\n.search-input:hover{\r\n    border-width: 3px;\r\n}\r\n\r\ninput:focus{\r\n    outline: none;\r\n}\r\n\r\n.logo {\r\n    background-image: url(" + require("../assets/starwarslogo.svg") + ");\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    background-size: contain;\r\n    width: 150px;\r\n    height: 35px;\r\n    float: left;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = 308
// module chunks = 2